export const objGraphsBarHtmlStyles = {
  container: {
    marginTop: '10px',
    marginBottom: '10px',
  },
};
